import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { EllipsisVertical } from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const Trigger = forwardRef<HTMLButtonElement>((_, ref) => {
  const { active, open } = DropdownMenu.useTrigger()
  const className = clsJoin(css.trigger, active && css.active)
  return (
    <button ref={ref} onClick={open} className={className} type="button">
      <EllipsisVertical className={css.icon} />
    </button>
  )
})
